export const DROP_TEXT_MAX_CHARS = 16_000;
/** Dragover is a protected data store: inspect format names only until the actual drop. */
export function dropKind(types) {
    if (types.includes('Files'))
        return 'files';
    if (types.includes('text/uri-list'))
        return 'link';
    if (types.includes('text/plain'))
        return 'text';
    return 'unsupported';
}
/** Links remain text in the draft; dropping one never navigates or fetches its target. */
export function droppedText(kind, getData) {
    if (kind === 'link') {
        const links = getData('text/uri-list').split(/\r?\n/).map(value => value.trim()).filter(value => value && !value.startsWith('#'));
        if (!links.length)
            throw new Error('This link could not be added. Paste it into your message instead.');
        for (const link of links) {
            let url;
            try {
                url = new URL(link);
            }
            catch {
                throw new Error('Drop an http or https link.');
            }
            if (url.protocol !== 'http:' && url.protocol !== 'https:')
                throw new Error('Drop an http or https link.');
        }
        return links.join('\n');
    }
    if (kind !== 'text')
        throw new Error('Drop supported files, plain text, or links.');
    const text = getData('text/plain').replace(/\u0000/g, '').trim();
    if (!text)
        throw new Error('There is no text to add.');
    return text;
}
export function appendDroppedText(draft, content) {
    const next = draft ? `${draft}${/\s$/.test(draft) ? '' : '\n\n'}${content}` : content;
    if (next.length > DROP_TEXT_MAX_CHARS)
        throw new Error('This text is too long to drop. Add a smaller selection (up to 16,000 characters including your draft).');
    return next;
}
//# sourceMappingURL=dropContent.js.map